import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";

import { Translate, I18n } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";
import { setAlert } from "../../../actions/alertActions";
import {
  NETWORK_TYPE,
  TOKEN_STATUS,
  CANCELLATION_REASONS,
  getNewCountryCode,
} from "../../utils/Utils";

import RequestNetworkAccess from "./RequestNetworkAccess";
import RequestPhysicalCard from "./RequestPhysicalCard";
import ActivateCard from "./ActivateCard";

import "../../../styles/components/evs/modals/ContractEV.scss";
import ConfirmBlock from "../../../components/evs/modals/ConfirmBlock";

import blockedCard from "../../../styles/images/blockedCard.svg"
import StatusBar from '../../utils/components/statusBar.js';
import arrow from "../../../styles/images/back_arrow.svg";
import frozenFrame from "../../../styles/images/frozen_frame.svg";
import toggle from "../../utils/evio-toggle";

//new imports 
import globe from "../../../styles/images/globe.svg";
import globev2 from "../../../styles/images/globeV2.svg";
import globev3 from "../../../styles/images/globeV3.svg";
import Chip from "@mui/material/Chip";
import Switch from "@mui/material/Switch";

import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import iconInfo from "../../../styles/images/iconInfo.svg";


class ContractEV extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      associatedEdit: false,
      selectedEV: {},
      selectedEVCardNetworkStatus: {},

      modals: {
        requestNetworkAccess: false,
        requestPhysicalCard: false,
        activateCard: false,
        associatePhysicalCard: false,
        confirmBlock: false,
      },

      missingCharacters: 300,
      cancellationReason: "",
      reasonOption1: false,
      reasonOption2: false,
      reasonOption3: false,
      needReplacement: null,
      rfidUIState: this.props.rfidUIState,
      cancellationDescription: "",
      reasonsCarryOverToRequestPhysicalCard: {},
      cancelCardPage: false,

      allowedCountry: [],
      blockedCountry: [],
      networksAllowed: true,
      listOfCountriesAPI: [],
      showBlockedCountries: false,
      initialLoadBlocked: [],
      initialLoadAllowed: [],
      isBlockCountryLoading: false,
      networksLoading: true,
    };

    this.displayNames = new Intl.DisplayNames(
      [getNewCountryCode(this.props.language.locale)],
      { type: "region" }
    );

    this.renderNetworks = this.renderNetworks.bind(this);
    this.renderNetworkControlButtons =
      this.renderNetworkControlButtons.bind(this);
    this.handleUnlockCard = this.handleUnlockCard.bind(this);
    this.formatCancellationReasonsAnswers =
      this.formatCancellationReasonsAnswers.bind(this);
    this.submitIsValid = this.submitIsValid.bind(this);
    this.handleChangeAllowedCountries =
      this.handleChangeAllowedCountries.bind(this);
    this.handleChangeBlockedCountries =
      this.handleChangeBlockedCountries.bind(this);
    this.renderCountryChip = this.renderCountryChip.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.networkGeneralStatus = this.networkGeneralStatus.bind(this);
    this.getAvailableCountries = this.getAvailableCountries.bind(this);
    this.syncListOfCountriesWithAvailableCountries =
      this.syncListOfCountriesWithAvailableCountries.bind(this);
    this.handleBlockCountry = this.handleBlockCountry.bind(this);
    this.translateCountryCodes = this.translateCountryCodes.bind(this);
    this.translateCountryCode = this.translateCountryCode.bind(this);
    this.getUpdatedCountriesv2 = this.getUpdatedCountriesv2.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    if (!this.state.cancelCardPage) {
      this.getAvailableCountries();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps?.selectedEV !== this.props.selectedEV ||
      prevProps?.selectedEVCardNetworkStatus !==
        this.props.selectedEVCardNetworkStatus
    ) {
      this.setState(
        {
          selectedEV: this.props.selectedEV,
          selectedEVCardNetworkStatus: this.props.selectedEVCardNetworkStatus,
        },
          () => {
            this.setState({ networksLoading: false });
          }
      );
    }

    if (prevProps.rfidUIState !== this.props.rfidUIState) {
      this.safeSetState({
        rfidUIState: this.props.rfidUIState,
      });
    }

    if (prevProps.selectedEV !== this.props.selectedEV) {
      this.getAvailableCountries();
    }

    if (prevProps.language.locale !== this.props.language.locale) {
      this.displayNames = new Intl.DisplayNames(
        [getNewCountryCode(this.props.language.locale)],
        { type: "region" }
      );
    }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  fetchEVVersions(callback) {
    axios
      .get("/api/private/evsdb/versions", {
        params: {
          brand: this.state.selectedBrand,
          model: this.state.selectedModel,
        },
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState({ versions: res.data }, callback);
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.code)
          this.props.setAlert(I18n.t(err.response.data.message), "danger");
        else this.props.setAlert(I18n.t("general_error"), "danger");
        if (axios.isCancel(err)) console.log("axios", err);
        else this.props.setAlert(I18n.t("general_error"), "danger");
      });
  }

  setModal(modal, bool, callback) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState(
      {
        modals: newModals,
      },
      callback
    );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  renderNetworkControlButtons(network) {
    if (this.state.selectedEV !== null) {
      if (
        network !== NETWORK_TYPE.MOBIE &&
        network !== NETWORK_TYPE.INTERNATIONAL_1
      ) {
        if (
          this.state.selectedEV?.contract?.contractType !== "user" &&
          network.tokens.find((element) => element.tokenType === "APP_USER")
            .status === "active"
        ) {
          return (
            <div className="net-field">
              <button
                type="button"
                className="join-bt"
                onClick={() => {
                  this.props.deactivateNetwork(
                    "EVIO",
                    this.state.selectedEV.contract._id
                  );
                }}
              >
                <Translate value="backOffice_contracts_network_deactivation_button" />
              </button>
            </div>
          );
        } else if (
          network.tokens.find((element) => element.tokenType === "APP_USER")
            .status === "inactive"
        ) {
          return (
            <div className="net-field">
              <button
                type="button"
                className="join-bt"
                onClick={() => {
                  this.props.activateNetwork(
                    "EVIO",
                    this.state.selectedEV.contract._id
                  );
                }}
              >
                <Translate value="backOffice_contracts_network_activation_button" />
              </button>
            </div>
          );
        } else if (
          network.tokens.find((element) => element.tokenType === "APP_USER")
            .status === TOKEN_STATUS.ACTIVATING
        ) {
          return (
            <div className="net-field">
              <button
                type="button"
                className="join-bt-loading"
                onClick={() => {}}
                disabled={true}
              >
                <Translate value="activating" />
              </button>
            </div>
          );
        } else if (
          network.tokens.find((element) => element.tokenType === "APP_USER")
            .status === TOKEN_STATUS.INACTIVATING
        ) {
          return (
            <div className="net-field">
              <button
                type="button"
                className="join-bt-loading"
                onClick={() => {}}
                disabled={true}
              >
                <Translate value="deactivating" />
              </button>
            </div>
          );
        }
      }
      if (network === NETWORK_TYPE.MOBIE) {
        if (
          this.state.selectedEV.contract?.contractType !== "user" &&
          this.state.selectedEVCardNetworkStatus.mobieStatus ===
            TOKEN_STATUS.ACTIVE
        ) {
          return (
            <button
              type="button"
              className="join-bt"
              onClick={() => {
                this.props.deactivateNetwork(
                  "MobiE",
                  this.state.selectedEV.contract._id
                );
              }}
            >
              <Translate value="backOffice_contracts_network_deactivation_button" />
            </button>
          );
        } else if (
          this.state.selectedEVCardNetworkStatus.mobieStatus ===
          TOKEN_STATUS.INACTIVE
        ) {
          return (
            <button
              type="button"
              className="join-bt"
              onClick={() => {
                this.props.activateNetwork(
                  "MobiE",
                  this.state.selectedEV.contract._id
                );
              }}
            >
              <Translate value="backOffice_contracts_network_activation_button" />
            </button>
          );
        } else if (
          this.state.selectedEVCardNetworkStatus.mobieStatus ===
          TOKEN_STATUS.ACTIVATING
        ) {
          return (
            <button
              type="button"
              className="join-bt-loading"
              onClick={() => {}}
              disabled={true}
            >
              <Translate value="activating" />
            </button>
          );
        } else if (
          this.state.selectedEVCardNetworkStatus.mobieStatus ===
          TOKEN_STATUS.INACTIVATING
        ) {
          return (
            <button
              type="button"
              className="join-bt-loading"
              onClick={() => {}}
              disabled={true}
            >
              <Translate value="deactivating" />
            </button>
          );
        }
      }
      if (network === NETWORK_TYPE.INTERNATIONAL_1) {
        if (
          this.state.selectedEV.contract?.contractType !== "user" &&
          this.state.selectedEVCardNetworkStatus.internationalStatus ===
            TOKEN_STATUS.ACTIVE
        ) {
          return (
            <button
              type="button"
              className="join-bt"
              onClick={() => {
                this.props.deactivateNetwork(
                  "Gireve",
                  this.state.selectedEV.contract._id
                );
              }}
            >
              <Translate value="backOffice_contracts_network_deactivation_button" />
            </button>
          );
        } else if (
          this.state.selectedEVCardNetworkStatus.internationalStatus ===
          TOKEN_STATUS.INACTIVE
        ) {
          return (
            <button
              type="button"
              className="join-bt"
              onClick={() => {
                this.props.activateNetwork(
                  "Gireve",
                  this.state.selectedEV.contract._id
                );
              }}
            >
              <Translate
                value={"backOffice_contracts_network_activation_button"}
              />
            </button>
          );
        } else if (
          this.state.selectedEVCardNetworkStatus.internationalStatus ===
          TOKEN_STATUS.ACTIVATING
        ) {
          return (
            <button
              type="button"
              className="join-bt-loading"
              onClick={() => {}}
              disabled={true}
            >
              <Translate value="activating" />
            </button>
          );
        } else if (
          this.state.selectedEVCardNetworkStatus.internationalStatus ===
          TOKEN_STATUS.INACTIVATING
        ) {
          return (
            <button
              type="button"
              className="join-bt-loading"
              onClick={() => {}}
              disabled={true}
            >
              <Translate value="deactivating" />
            </button>
          );
        }
      }
    }
  }

  handleUnlockCard(block) {
    const patch = {
      activeBlock: block,
      contractId: this.props?.selectedEV?.contract?._id,
    };

    axios
      .patch("/api/private/contracts/switchBlockCard", patch)
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState({
            rfidUIState: res.data.rfidUIState,
          });

          this.props.updaterfidUIState(res.data.rfidUIState);
        }
      })
      .catch((err) => {});
  }

  formatCancellationReasonsAnswers() {
    let cancellation_reason = "";
    if (this.state.reasonOption1) {
      cancellation_reason = "THEFT";
    } else if (this.state.reasonOption2) {
      cancellation_reason = "LOST";
    } else if (this.state.reasonOption3) {
      cancellation_reason = "OTHER";
    }

    const contractId = this.props?.selectedEV?.contract?._id || "";

    let description = "";
    if (cancellation_reason === "OTHER") {
      description = this.state.cancellationDescription || "";
    }

    const needReplacement =
      this.props.brand?.brandName === "EVIO"
        ? this.state.needReplacement
        : false;

    const reasons = {
      contractId,
      isNewCard: needReplacement,
      reason: {
        description: description,
        reason: cancellation_reason,
      },
    };

    this.safeSetState({ reasonsCarryOverToRequestPhysicalCard: reasons });

    if (needReplacement) {
      this.setModal("requestPhysicalCard", true);
    } else {
      this.setModal("confirmBlock", true);
    }
    return reasons;
  }

  handleCancelRFID = () => {
    const reasons = this.state?.reasonsCarryOverToRequestPhysicalCard;
    axios
      .patch("/api/private/contracts/cancelRFID", {
        ...reasons,
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.fetchFleets();
          this.props.setAlert(
            I18n.t("contractsPhysicalCard_messageSuccessCanceled"),
            "primary"
          );
          this.props.onHide();
        }
      })
      .catch((err) => {
        this.props.setAlert(I18n.t(err.response.data.message), "danger");
      });
  };

  submitIsValid() {
    let {
      reasonOption1,
      reasonOption2,
      reasonOption3,
      cancellationDescription,
      needReplacement,
    } = this.state;

    let reasonForCancellation = reasonOption1 || reasonOption2 || reasonOption3;

    let cancellationReason = reasonOption3
      ? cancellationDescription.length > 0
      : true;

    let replacementNeeded =
      this.props.brand?.brandName === "EVIO"
        ? needReplacement !== null && needReplacement !== undefined
        : true;

    return !(reasonForCancellation && cancellationReason && replacementNeeded);
  }

  resetState = () => {
    this.setState({
      networksLoading: true,
      associatedEdit: false,
      selectedEV: {},
      selectedEVCardNetworkStatus: {},
      missingCharacters: 300,
      reasonOption1: false,
      reasonOption2: false,
      reasonOption3: false,
      needReplacement: false,
      rfidUIState: this.props.rfidUIState,
      cancelCardPage: false,
      cancellationDescription: "",
      showBlockedCountries: false,
    });
  };

  //New functions for this development (network normalization)
  getUpdatedCountriesv2(prevBlockedCountry, blockedCountry) {
    const added =
      Array.isArray(prevBlockedCountry) && Array.isArray(blockedCountry)
        ? blockedCountry.filter((c) => !prevBlockedCountry.includes(c))
        : [];
    const removed =
      Array.isArray(prevBlockedCountry) && Array.isArray(blockedCountry)
        ? prevBlockedCountry.filter((c) => !blockedCountry.includes(c))
        : [];
    const updatedCountries = [...added, ...removed];
    if (updatedCountries.length === 0) {
      return updatedCountries;
    } else {
      return updatedCountries;
    }
  }

  handleChangeAllowedCountries = (event) => {
    //Local function to update the status of the selected/blocked countries
    const {
      target: { value },
    } = event;
    const newAllowed = typeof value === "string" ? value.split(",") : value;

    this.setState((prevState) => {
      // Countries removed from allowedCountry
      const removedFromAllowed = prevState.allowedCountry.filter(
        (country) => !newAllowed.includes(country)
      );
      // Add removed countries to blockedCountry (avoid duplicates)
      const updatedBlocked = [
        ...prevState.blockedCountry.filter(
          (country) => !newAllowed.includes(country)
        ),
        ...removedFromAllowed.filter(
          (country) => !prevState.blockedCountry.includes(country)
        ),
      ];
      return {
        allowedCountry: newAllowed,
        blockedCountry: updatedBlocked,
      };
    });
  };

  handleChangeBlockedCountries = (event) => {
    //Local function to update the status of the selected/blocked countries
    const {
      target: { value },
    } = event;
    const newBlocked = typeof value === "string" ? value.split(",") : value;

    this.setState((prevState) => {
      // Countries removed from blockedCountry
      const removedFromBlocked = prevState.blockedCountry.filter(
        (country) => !newBlocked.includes(country)
      );
      // Add removed countries to allowedCountry (avoid duplicates)
      const updatedAllowed = [
        ...prevState.allowedCountry,
        ...removedFromBlocked.filter(
          (country) => !prevState.allowedCountry.includes(country)
        ),
      ];
      return {
        blockedCountry: newBlocked,
        allowedCountry: updatedAllowed.filter(
          (country) => !newBlocked.includes(country)
        ),
      };
    });
  };

  getAvailableCountries() {
    // This will fetch the list of available countries
    axios
      .get("/api/private/countries/available", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState({
            listOfCountriesAPI: res.data,
          });

          this.syncListOfCountriesWithAvailableCountries(res.data);

          if (
            this.state?.listOfCountriesAPI.length ===
            this.state?.blockedCountry.length
          ) {
            this.setState({ networksAllowed: false });
          } else {
            this.setState({ networksAllowed: true });
          }
        }
      })
      .catch((err) => {
        this.props.setAlert(I18n.t("general_error"), "danger");
      })
  }

  syncListOfCountriesWithAvailableCountries(listOfCountries) {
    // This function will compare the list of available countries and deduce
    // Total countries - blockedCountries = allowedCountries
    // blockedCountries = blockedCountries

    //This part of the code is using arrays with countryCodes since its agnostic from the user language
    const networkGroups = this.props.selectedEV?.contract?.networkGroups;
    const networkPublicGroup = Array.isArray(networkGroups)
      ? networkGroups.find((group) => group?.networkGroup === "public")
      : null;

    const blockedCountries = networkPublicGroup?.blockedCountries;
    const normalizedListOfAllowedCountries = listOfCountries.map(
      (e) => e.countryCode
    );

    const normalizedListOfActiveCountries =
      normalizedListOfAllowedCountries.filter(
        (item) => !blockedCountries.includes(item)
      );

    this.safeSetState({
      allowedCountry: normalizedListOfActiveCountries,
      blockedCountry: blockedCountries,
      initialLoadBlocked: blockedCountries,
      initialLoadAllowed: normalizedListOfActiveCountries,
    });
  }

  handleBlockCountry() {
    //convert the list of blockedCountry to country codes again
    const put = {
      blockedCountries: this.state.blockedCountry,
    };

    this.safeSetState({ isBlockCountryLoading: true }, () => {
      axios
        .put(
          `/api/private/contracts/${this.props.selectedEV.contract._id}/networks/public/blocked-countries`,
          put,
          {
            cancelToken: new CancelToken((c) => (this.cancel = c)),
          }
        )
        .then((res) => {
          if (res.status === 200) {
            const oldGroups = this.props.selectedEV.contract.networkGroups || [];
            const updatedGroups = oldGroups.map((group) =>
              group.networkGroup === "public"
                ? { ...group, blockedCountries: res.data.blockedCountries }
                : group
            );

            this.props.updateSelectedEV({
              ...this.props.selectedEV,
              contract: {
                ...this.props.selectedEV.contract,
                networkGroups: updatedGroups,
              },
            });

            this.props.setAlert(
              I18n.t("networks_successUpdate"),
              "primary"
            );
          }
        })
        .catch((err) => {
          this.props.setAlert(I18n.t("general_error"), "danger");
        })
        .finally(() => {
          this.safeSetState({ isBlockCountryLoading: false });
        });
    });
  }

  networkGeneralStatus() {
    if (!this.state.networksLoading){
      if (
        this.state.networksAllowed === false ||
        this.state.allowedCountry.length === 0
      ) {
        return (
          <span className="tooltip-container networksHeaders-left-tooltip">
            <Chip
              label={I18n.t("networks_allBlocked")}
              sx={{
                border: "2px solid #FF665A",
                color: "#B02D27",
                backgroundColor: "white",
              }}
            />
            <div className="custom-tooltip" style={{ marginTop: "1rem" }}>
              <Translate value="network_access_status_all_blocked_tooltip" />
            </div>
          </span>
        );
      } else {
        if (
          this.state.allowedCountry.length ===
          this.state.listOfCountriesAPI.length
        ) {
          return (
            <span className="tooltip-container networksHeaders-left-tooltip">
              <Chip
                label={I18n.t("networks_everythingAllowed")}
                sx={{
                  border: "2px solid #36BFAB",
                  color: "#005642",
                  backgroundColor: "white",
                }}
              />
              <div className="custom-tooltip" style={{ marginTop: "1rem" }}>
                <Translate value="network_access_status_all_allowed_tooltip" />
              </div>
            </span>
          );
        } else {
          return (
            <span className="tooltip-container networksHeaders-left-tooltip">
              <Chip
                label={I18n.t("networks_partiallyAvailable")}
                sx={{
                  border: "2px solid #F3BB3C",
                  color: "#7A5900",
                  backgroundColor: "white",
                }}
              />
              <div className="custom-tooltip" style={{ marginTop: "1rem" }}>
                <Translate value="network_access_status_partially_available_tooltip" />
              </div>
            </span>
          );
        }
      }
    } else {
      return null;
    }

  }

  renderNetworks() {
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: "33%",
          minWidth: 250,
        },
      },
    };

    const displayNames = this.displayNames;

    this.networkGeneralStatus();

    if(this.state.networksLoading) {
      return (
        null
      );
    }
    return (
      <>
        <div className="physical-card-main-container">
          <div className="physical-card-container">
            <div>
              <div className="networksHeaders">
                <div className="networksHeaders-left">
                  <div className="networksHeaders-left-img">
                    <img src={globe} alt="globe" />
                  </div>
                  <div className="networksHeaders-left-info">
                    <p className="networksHeaders-left-title">
                      <b>
                        <Translate value="networks_networksAccess" />
                      </b>
                    </p>
                    <div>{this.networkGeneralStatus()}</div>
                  </div>
                  <div className="tooltip-container networksHeaders-left-tooltip">
                    <img src={iconInfo} alt="" />
                    <div className="custom-tooltip">
                      <Translate value="networks_tooltip" />
                    </div>
                  </div>
                </div>
                <div className="networksHeaders-right">
                  <div className="networksHeaders-right-row">
                    <p className="networksHeaders-right-img">
                      {this.state.networksAllowed
                        ? I18n.t("networks_active")
                        : I18n.t("networks_blocked")}
                    </p>
                    <Switch
                      className="evio-green-switch"
                      color="#006B5E"
                      checked={this.state.networksAllowed}
                      onChange={() => {
                        let allCountryCodes = this.state.listOfCountriesAPI.map(
                          (country) => country.countryCode,
                        );
                        this.safeSetState((prevState) => ({
                          networksAllowed: !prevState.networksAllowed,
                          blockedCountry: !prevState.networksAllowed
                            ? []
                            : allCountryCodes,
                          allowedCountry: prevState.networksAllowed
                            ? []
                            : allCountryCodes,
                        }));
                      }}
                    />
                  </div>
                  <div className="networksHeaders-right-countries">
                    <img src={globev2} alt="globe" />
                    {this.state.networksAllowed ? (
                      <p>
                        {`${this.state.allowedCountry.length}/${this.state.listOfCountriesAPI.length} `}
                        <Translate value="networks_countries" />
                      </p>
                    ) : (
                      <p>
                        {`0/${this.state.listOfCountriesAPI.length} `}
                        <Translate value="networks_countries" />
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <>
                <div className="Divider"></div>
                <div className="network Bodies">
                  <div className="allowedCountries">
                    <div className="allowedCountries-header">
                      <img src={globev3} alt="globe" />
                      <p style={{ color: "black" }}>
                        <Translate value="networks_allowedCountries" />
                      </p>
                      <Chip
                        label={this.state.allowedCountry.length}
                        className="allowedCountries-chip"
                      />
                    </div>
                    <div className="allowedCountries-select">
                      <FormControl sx={{ l: 2, width: "100%" }}>
                        <InputLabel id="demo-multiple-checkbox-label">
                          <Translate value="networks_selectCountries" />
                        </InputLabel>
                        <Select
                          labelId="demo-multiple-checkbox-label"
                          id="demo-multiple-checkbox"
                          multiple
                          value={this.state.allowedCountry}
                          onChange={this.handleChangeAllowedCountries}
                          input={
                            <OutlinedInput
                              label={I18n.t("networks_selectCountries")}
                            />
                          }
                          renderValue={(selected) =>
                            this.translateCountryCodes(selected).join(", ")
                          }
                          MenuProps={MenuProps}
                        >
                          {this.state.listOfCountriesAPI.map((country) => (
                            <MenuItem
                              key={country.countryCode}
                              value={country.countryCode}
                            >
                              <Checkbox
                                checked={this.state.allowedCountry.includes(
                                  country.countryCode,
                                )}
                              />
                              <ListItemText
                                primary={`${
                                  country.countryCode
                                } - ${displayNames.of(country.countryCode)}`}
                              />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div>
                      {this.state.allowedCountry &&
                      this.state.allowedCountry.length > 0
                        ? this.state.allowedCountry.map((country) => (
                            <React.Fragment key={country}>
                              {this.renderCountryChip(country, "allowed")}
                            </React.Fragment>
                          ))
                        : null}
                    </div>
                  </div>
                  <div className="blockedCountries">
                    <div
                      className="blockedCountries-header"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <img src={globev3} alt="globe" />
                      <p style={{ color: "black", margin: 0 }}>
                        <Translate value="networks_allowedCountriesBlocked" />
                      </p>
                      <Chip
                        label={this.state?.blockedCountry?.length}
                        className="blockedCountries-chip"
                        style={{ marginLeft: 8 }}
                      />
                      {/* Inline arrow icon for toggle */}
                      <span
                        onClick={() =>
                          this.setState({
                            showBlockedCountries:
                              !this.state.showBlockedCountries,
                          })
                        }
                        className="toggle-blocked-countries-arrow"
                        aria-label={
                          this.state.showBlockedCountries
                            ? I18n.t("networks_hideBlockedCountries")
                            : I18n.t("networks_showBlockedCountries")
                        }
                        title={
                          this.state.showBlockedCountries
                            ? I18n.t("networks_hideBlockedCountries")
                            : I18n.t("networks_showBlockedCountries")
                        }
                      >
                        {this.state.showBlockedCountries ? (
                          <span className="toggle-blocked-countries-arrow-icon">
                            ▼
                          </span>
                        ) : (
                          <span className="toggle-blocked-countries-arrow-icon">
                            ▲
                          </span>
                        )}
                      </span>
                    </div>
                    <div
                      className="divToHideShow"
                      style={{
                        display: this.state.showBlockedCountries
                          ? "block"
                          : "none",
                      }}
                    >
                      <div className="blockedCountries-select">
                        <FormControl sx={{ l: 2, width: "100%" }}>
                          <InputLabel id="demo-multiple-checkbox-label">
                            <Translate value="networks_selectCountries" />
                          </InputLabel>
                          <Select
                            labelId="demo-multiple-checkbox-label"
                            id="demo-multiple-checkbox"
                            multiple
                            value={this.state.blockedCountry}
                            onChange={this.handleChangeBlockedCountries}
                            input={
                              <OutlinedInput
                                label={I18n.t("networks_selectCountries")}
                              />
                            }
                            renderValue={(selected) =>
                              this.translateCountryCodes(selected).join(", ")
                            }
                            MenuProps={MenuProps}
                          >
                            {this.state.listOfCountriesAPI.map((country) => (
                              <MenuItem
                                key={country.countryCode}
                                value={country.countryCode}
                              >
                                <Checkbox
                                  checked={this.state.blockedCountry.includes(
                                    country.countryCode,
                                  )}
                                />
                                <ListItemText
                                  primary={`${
                                    country.countryCode
                                  } - ${displayNames.of(country.countryCode)}`}
                                />
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                      <div>
                        {Array.isArray(this.state.blockedCountry) &&
                        this.state.blockedCountry.length > 0
                          ? this.state.blockedCountry.map((country) => {
                              try {
                                return (
                                  <React.Fragment key={country}>
                                    {this.renderCountryChip(country, "blocked")}
                                  </React.Fragment>
                                );
                              } catch (err) {
                                return null;
                              }
                            })
                          : null}
                      </div>
                    </div>

                    {this.listOfChanges(
                      this.state.initialLoadBlocked,
                      this.state.blockedCountry,
                    ).length ? (
                      <div style={{ marginTop: "12px", textAlign: "right" }}>
                        <div className="Divider"></div>
                        <div style={{ display: "flex", textAlign: "left" }}>
                          {this.renderListOfChanges(
                            this.state.initialLoadBlocked,
                            this.state.blockedCountry,
                          )}
                        </div>
                        <div style={{ marginTop: "1rem" }}>
                          {this.state.isBlockCountryLoading ? (
                            <div className="spinner-container">
                              <span className="loading-spinner" />
                            </div>
                          ) : (
                            <button
                              type="button"
                              className="physic-card-bt"
                              onClick={() => {
                                this.handleBlockCountry();
                              }}
                            >
                              <Translate value="update_action" />
                            </button>
                          )}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
      </>
    );

  }

  renderCountryChip(labelData, type) {
    const listOfChanges = this.listOfChanges(this.state.initialLoadBlocked, this.state.blockedCountry);
    const changeToYellow = listOfChanges.includes(labelData)
    return (
      <Chip
        className="country-chip"
        label={this.translateCountryCode(labelData)}
        variant="outlined"
        onDelete={this.handleDelete(labelData, type)}
        style={
          changeToYellow
            ? {
                border: "2px solid #F3BB3C", // informative yellow/orange border
                color: "#7A5900", // informative yellow/orange text
              }
            : {}
        }
      />
    );
  }

  listOfChanges(prevBlockedCountry, blockedCountry) {
    const added =
      Array.isArray(prevBlockedCountry) && Array.isArray(blockedCountry)
        ? blockedCountry.filter((c) => !prevBlockedCountry.includes(c))
        : [];
    const removed =
      Array.isArray(prevBlockedCountry) && Array.isArray(blockedCountry)
        ? prevBlockedCountry.filter((c) => !blockedCountry.includes(c))
        : [];
    const updatedCountries = [...added, ...removed];
    return updatedCountries;
  }

  renderListOfChanges(prevBlockedCountry, blockedCountry) {
    const displayNames = this.displayNames;

    const added =
      Array.isArray(prevBlockedCountry) && Array.isArray(blockedCountry)
        ? blockedCountry.filter((c) => !prevBlockedCountry.includes(c))
        : [];
    const removed =
      Array.isArray(prevBlockedCountry) && Array.isArray(blockedCountry)
        ? prevBlockedCountry.filter((c) => !blockedCountry.includes(c))
        : [];
    const updatedCountries = [...added, ...removed];

    // Convert to comma-separated row of country names
    const countryNamesRow = updatedCountries
      .map((country) => displayNames.of(country))
      .join(", ");

    if (countryNamesRow.length === 0) {
      return null;
    } else {
      return (
        <div className="info-update-box">
          <div className="info-update-box-icon">
            <img src={iconInfo} alt="" />
          </div>
          <div className="info-update-box-content">
            <b>
              <Translate value="networks_followingWillBeUpdated" />
            </b>
            {countryNamesRow}
          </div>
        </div>
      );
    }
  }

  handleDelete = (labelData, type) => () => {


    if (type === "allowed") {
      this.safeSetState((prevState) => {
        // Remove from allowedCountry
        const updatedAllowed = prevState.allowedCountry.filter(
          (country) => country !== labelData,
        );
        // Add to blockedCountry if not already present
        const updatedBlocked = prevState.blockedCountry.includes(labelData)
          ? prevState.blockedCountry
          : [...prevState.blockedCountry, labelData];
        return {
          allowedCountry: updatedAllowed,
          blockedCountry: updatedBlocked,
        };
      });
    } else {
      this.safeSetState(
        (prevState) => {
          // Remove from blockedCountry
          const updatedBlocked = prevState.blockedCountry.filter(
            (country) => country !== labelData
          );
          // Add to allowedCountry if not already present
          const updatedAllowed = prevState.allowedCountry.includes(labelData)
            ? prevState.allowedCountry
            : [...prevState.allowedCountry, labelData];
          return {
            blockedCountry: updatedBlocked,
            allowedCountry: updatedAllowed,
          };
        }
      );
    }
  };

  translateCountryCodes = (countries) => {
    const displayNames = this.displayNames;
    const translatedCountries = countries.map((code) => {
      const countryObj = this.state.listOfCountriesAPI.find(
        (c) => c.countryCode === code
      );
      return countryObj ? displayNames.of(countryObj.countryCode) : code;
    });
    return translatedCountries;
  };

  translateCountryCode = (code) => {
    const displayNames = this.displayNames;
    const countryObj = this.state.listOfCountriesAPI.find(
      (c) => c.countryCode === code
    );
    return countryObj ? displayNames.of(countryObj.countryCode) : code;
  };

  render() {
    return (
      this.props.selectedEV && (
        <>
          <Modal
            id="contractEV"
            show={this.props.show}
            onHide={this.props.onHide}
            onExited={this.resetState}
            centered
            style={{ paddingBottom: "1rem", paddingTop: "1rem" }}
            className={
              this.state.modals.requestPhysicalCard
                ? "transparent-modal-bg"
                : ""
            }
            onShow={() => {
              this.safeSetState({
                cancellationReason: "",
                reasonOption1: false,
                reasonOption2: false,
                reasonOption3: false,
                needReplacement:
                  this.props.brand?.brandName === "EVIO" ? null : false,
              });
            }}
          >
            <Modal.Header>
              <Modal.Title>
                {this.state.cancelCardPage ? (
                  <div className="ModalTitleDiv">
                    <img
                      src={arrow}
                      alt="Return"
                      className="arrow ModalTitleImage"
                      onClick={() =>
                        this.safeSetState({
                          cancelCardPage: false,
                        })
                      }
                      aria-label="Back"
                    />

                    <span className="ModalTitleText">
                      <Translate value="contractsPhysicalCard_title" />
                    </span>
                  </div>
                ) : (
                  <Translate value="backOffice_network_contracts_title" />
                )}
              </Modal.Title>
            </Modal.Header>
            <div className="evio-card-container">
              <div
                className="evio-card"
                style={{
                  ...(this.props.brand &&
                    this.props.brand.brandName !== "EVIO" && {
                      backgroundImage: `url('${
                        this.props.brand.icons?.cards?.big ?? ""
                      }')`,
                    }),
                  position: "relative",
                }}
              >
                {this.props.rfidUIState?.blockToggleState && (
                  <>
                    <div className="BlockedDiv">
                      <img
                        src={frozenFrame}
                        alt="frozenFrame"
                        className="frozenFrame-bg"
                        onClick={() =>
                          this.safeSetState({
                            cancelCardPage: false,
                          })
                        }
                      />
                      <div className="blocked-pin-box blocked-pin-box-small">
                        <img
                          src={blockedCard}
                          className="icon blockedCard-icon blockedCard-small"
                          alt=""
                        />
                        <p className="blocked-pin-text blocked-pin-text-small">
                          <Translate value="contracts_cardBlocked" />
                        </p>
                      </div>
                    </div>
                  </>
                )}

                <span>
                  <p>{this.props.selectedEV.contract?.name}</p>
                  <p>{this.props.selectedEV.contract?.cardName}</p>
                </span>
              </div>
              <div className="card-type">
                <Translate value={this.props.selectedEV.contract?.cardType} />
              </div>
            </div>

            {this.state.cancelCardPage ? (
              <Modal.Body>
                <div className="body-container">
                  <div className="physical-card-main-container">
                    <div>
                      <div className="physical-card-container">
                        <StatusBar
                          text={I18n.t("contractsPhysicalCard_reason")}
                          active={
                            this.state.reasonOption1 ||
                            this.state.reasonOption2 ||
                            this.state.reasonOption3
                          }
                        />
                        <p className="lightText">
                          <Translate value="contractsPhysicalCard_reasonSubtitle" />
                        </p>
                        <div className="cancellation-reasons-container">
                          <label className="cancellation-reason-label">
                            <input
                              style={{
                                marginBottom: "0.5rem",
                              }}
                              type="radio"
                              name="cancellationReason"
                              checked={
                                this.state.cancellationReason === "THEFT"
                              }
                              onChange={() =>
                                this.safeSetState({
                                  cancellationReason: "THEFT",
                                  reasonOption1: true,
                                  reasonOption2: false,
                                  reasonOption3: false,
                                })
                              }
                            />
                            <div>
                              <span>{CANCELLATION_REASONS.THEFT}</span>
                            </div>
                          </label>
                          <label className="cancellation-reason-label">
                            <input
                              type="radio"
                              name="cancellationReason"
                              checked={this.state.cancellationReason === "LOST"}
                              onChange={() =>
                                this.safeSetState({
                                  cancellationReason: "LOST",
                                  reasonOption1: false,
                                  reasonOption2: true,
                                  reasonOption3: false,
                                })
                              }
                            />
                            <span>{CANCELLATION_REASONS.LOST}</span>
                          </label>
                          <label className="cancellation-reason-label">
                            <input
                              type="radio"
                              name="cancellationReason"
                              checked={
                                this.state.cancellationReason === "OTHER"
                              }
                              onChange={() =>
                                this.safeSetState({
                                  cancellationReason: "OTHER",
                                  reasonOption1: false,
                                  reasonOption2: false,
                                  reasonOption3: true,
                                })
                              }
                            />
                            <span>{CANCELLATION_REASONS.OTHER}</span>
                          </label>
                        </div>
                      </div>
                      {this.state.reasonOption3 && (
                        <div className="physical-card-container physical-card-container-margin-top">
                          <div className="cancellation-description-container">
                            <StatusBar
                              text={I18n.t(
                                "contractsPhysicalCard_DescriptionOfTheOccurrence"
                              )}
                              active={
                                this.state?.cancellationDescription?.length > 0
                              }
                            />
                            <p className="lightText">
                              <Translate value="contractsPhysicalCard_DescriptionDetailed" />
                            </p>
                          </div>
                          <textarea
                            id="cancellation_description"
                            name="cancellation_description"
                            rows="4"
                            cols="50"
                            maxLength="300"
                            className="cancellation-description-textarea"
                            value={this.state.cancellationDescription || ""}
                            onChange={(e) => {
                              this.safeSetState({
                                cancellationDescription: e.target.value,
                                missingCharacters: 300 - e.target.value.length,
                              });
                            }}
                          ></textarea>
                          <span className="cancellation-description-remaining">
                            <Translate value="contractsPhysicalCard_missingCharacters" />{" "}
                            {this.state.missingCharacters.toString()}
                          </span>
                        </div>
                      )}

                      {this.props.brand.brandName === "EVIO" && (
                        <div
                          className={`physical-card-container physical-card-container-margin-top${
                            !this.state.cancellationReason
                              ? " physical-card-container--disabled"
                              : ""
                          }`}
                        >
                          <div>
                            <StatusBar
                              text={I18n.t("contractsPhysicalCard_intendReplace")}
                              active={
                                this.state.needReplacement != null ? true : false
                              }
                            />
                          </div>
                          <p className="lightText">
                            <Translate value="contractsPhysicalCard_intendReplaceSubtitle" />
                          </p>

                          <div className="need-replacement-row">
                            <div className="need-replacement-options">
                              <label className="cancellation-reason-label need-replacement-label">
                                <input
                                  type="radio"
                                  name="needReplacement"
                                  checked={this.state.needReplacement === true}
                                  onChange={() =>
                                    this.safeSetState({
                                      needReplacement: true,
                                    })
                                  }
                                  className="need-replacement-radio"
                                  disabled={!this.state.cancellationReason}
                                />
                                <span>
                                  <Translate value="contractsPhysicalCard_replaceCardYes" />
                                </span>
                              </label>

                              <label className="cancellation-reason-label need-replacement-label need-replacement-label--ml">
                                <input
                                  type="radio"
                                  name="needReplacement"
                                  checked={this.state.needReplacement === false}
                                  onChange={() =>
                                    this.safeSetState({
                                      needReplacement: false,
                                    })
                                  }
                                  disabled={!this.state.cancellationReason}
                                />
                                <span>
                                  <Translate value="contractsPhysicalCard_replaceCardNo" />
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="cancel-card-btn-container">
                        <button
                          disabled={this.submitIsValid()}
                          type="button"
                          className="physic-card-bt cancel-card-btn"
                          onClick={() => {
                            this.formatCancellationReasonsAnswers();
                          }}
                        >
                          <Translate value="contractsPhysicalCard_title" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal.Body>
            ) : (
              <Modal.Body>
                <div className="body-container">
                  {this.renderNetworks(
                    this.state.selectedEVCardNetworkStatus
                  )}
                  {this.state.selectedEVCardNetworkStatus.physicalCardStatus ===
                  TOKEN_STATUS.ACTIVE ? (
                    <div className="physical-card-main-container">
                      <div className="physical-card-container">
                        {(this.props.wasAdmin ||
                          this.props.userPackage?.cardAssociationEnabled) && (
                          <button
                            type="button"
                            className="associate-physic-card-bt"
                            onClick={() => {
                              this.safeSetState({
                                selectedContract:
                                  this.props.selectedEV.contract,
                                associatedEdit: true,
                              });
                              this.setModal("associatePhysicalCard", true);
                            }}
                          >
                            <Translate value="backOffice_network_edit_associated_physicalCard_bt" />
                          </button>
                        )}
                      </div>
                    </div>
                  ) : this.state.selectedEVCardNetworkStatus
                      .physicalCardStatus === TOKEN_STATUS.TO_REQUEST ? (
                    <div className="physical-card-main-container">
                      <div className="physical-card-container">
                        <span>
                          <p>
                            <Translate value="backOffice_network_physicalCard_toRequest" />
                          </p>
                        </span>
                        <button
                          type="button"
                          className={
                            this.props.selectedEV.contract
                              .cardPhysicalStateInfo !== "ASSOCIATED"
                              ? "button-requested disabled-btn"
                              : "button-requested"
                          }
                          onClick={() => {
                            this.setModal("activateCard", true, () =>
                              this.props.onJoin()
                            );
                          }}
                          disabled={
                            !(
                              this.props.selectedEV.contract
                                .cardPhysicalStateInfo === "ASSOCIATED"
                            )
                          }
                        >
                          <Translate value="backOffice_network_activate_bt" />
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="physical-card-main-container">
                      <div className="physical-card-container">
                        <span>
                          <p>
                            <Translate value="backOffice_network_physicalCard_request_associate_subTitle" />
                          </p>
                        </span>
                        <div className="physic-associate-container">
                          {this.props.brand?.brandName === "EVIO" && (
                            <button
                              type="button"
                              className="physic-card-bt"
                              onClick={() => {
                                this.safeSetState(
                                  {
                                    selectedContract:
                                      this.props.selectedEV.contract,
                                  },
                                  () =>
                                    this.setModal(
                                      "requestPhysicalCard",
                                      true,
                                      () => this.props.onJoin()
                                    )
                                );
                              }}
                            >
                              <Translate value="backOffice_network_request_physicalCard_bt" />
                            </button>
                          )}

                          {(this.props.wasAdmin ||
                            this.props.userPackage?.cardAssociationEnabled) && (
                            <button
                              type="button"
                              className="associate-physic-card-bt"
                              onClick={() => {
                                this.safeSetState({
                                  selectedContract:
                                    this.props.selectedEV.contract,
                                });
                                this.setModal(
                                  "associatePhysicalCard",
                                  true,
                                  () => this.props.onJoin()
                                );
                              }}
                            >
                              <Translate value="backOffice_network_associate_physicalCard_bt" />
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {this.state?.rfidUIState?.enableBlockButton && (
                      <div className="physical-card-main-container">
                        <div className="physical-card-container">
                          <div className="physic-associate-container">
                            <div className="rfid-block-left">
                              <div className="rfid-row">
                                <div>
                                  <p className="rfid-title">
                                    <span>
                                      <Translate value="general_blockCard" />
                                    </span>
                                  </p>
                                  <p>
                                    {this.state?.rfidUIState
                                      ?.blockToggleState ? (
                                      <Translate value="block_card_inactive" />
                                    ) : (
                                      <Translate value="block_card_active" />
                                    )}
                                  </p>
                                </div>
                                <div className="custom-control custom-switch rfid-switch">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="customSwitch1"
                                    checked={
                                      this.state.rfidUIState.blockToggleState
                                    }
                                    onChange={(e) => {
                                      if (!e.target.checked) {
                                        if (
                                          this.state?.rfidUIState
                                            ?.blockToggleState === true
                                        ) {
                                          this.handleUnlockCard(false);
                                        }
                                      } else {
                                        this.handleUnlockCard(true);
                                      }
                                    }}
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customSwitch1"
                                  ></label>
                                </div>
                              </div>
                            </div>
                            <div className="rfid-cancel-btn-row">
                              {this.state.rfidUIState.showCancelButton && (
                                <button
                                  type="button"
                                  className="physic-card-bt"
                                  onClick={() => {
                                    this.safeSetState({
                                      cancelCardPage: true,
                                    });
                                  }}
                                >
                                  <Translate value="contractsPhysicalCard_title" />
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                </div>
              </Modal.Body>
            )}
          </Modal>

          <ConfirmBlock
            show={this.state.modals.confirmBlock}
            onHide={() => {
              this.setModal("confirmBlock", false);
            }}
            onSuccess={this.handleCancelRFID}
            replacement={false}
            reasons={this.state?.reasonsCarryOverToRequestPhysicalCard}
            address={""}
            addressCode={""}
            addressCountry={""}
          />

          <RequestNetworkAccess
            show={this.state.modals.requestNetworkAccess}
            onHide={() => this.setModal("requestNetworkAccess", false)}
            selectedEV={this.props.selectedEV}
            fetchFleets={this.props.fetchFleets}
          />
          <ActivateCard
            show={this.state.modals.activateCard}
            onHide={() => this.setModal("activateCard", false)}
            selectedEV={this.props.selectedEV}
            fetchFleets={this.props.fetchFleets}
          />
          <RequestPhysicalCard
            show={this.state.modals.requestPhysicalCard}
            onHide={() => this.setModal("requestPhysicalCard", false)}
            selectedEV={this.props.selectedEV}
            fetchFleets={this.props.fetchFleets}
            requestNewPhysicalCard={this.state.cancelCardPage}
            reasonsCarryOverToRequestPhysicalCard={
              this.state?.reasonsCarryOverToRequestPhysicalCard
            }
            onCloseParentModal={this.props.onHide}
          />
          <RequestPhysicalCard
            show={this.state.modals.associatePhysicalCard}
            onHide={() => {
              this.safeSetState(
                { associatedEdit: false, selectedContract: null },
                () => this.setModal("associatePhysicalCard", false)
              );
            }}
            associate={true}
            associatedEdit={this.state.associatedEdit}
            selectedContract={this.state.selectedContract}
            fetchFleets={this.props.fetchFleets}
          />
        </>
      )
    );
  }
}

const mapStateToProps = (state) => ({
  language: state.i18n,
  brand: state.app.brand,
  country: state.account.accountData.country,
  isCompany: state.account.isCompany,
  wasAdmin: state.account.wasAdmin,
  userPackage: state.account.accountData.userPackage,
});

export default connect(mapStateToProps, { setAlert })(ContractEV);
